export default {
  "content": "<title>Mic Circle</title><path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M224 368h64m48-143.7v23.92c0 39.42-40.58 71.48-80 71.48s-80-32.06-80-71.48V224.3m80 95.7v48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><rect x=\"208\" y=\"128\" width=\"96\" height=\"160\" rx=\"48\" ry=\"48\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};